export default () => ({
    scope: {
        isSuperUser: '=',
    },
    template: require('./superUserPanelTemplate.html'),
});
